import { Form, Formik, FormikHelpers } from 'formik';
import Link from 'next/link';
import React, { ReactNode, useState } from 'react';
import { ErrorMessage } from '../../../../base-components/ErrorMessage';
import { FormDebug } from '../../../../base-components/FormDebug';
import { Role } from './Role';
import styles from './Wizard.module.scss';
import { FormData } from './Wizard.type';

interface Props {
    children: ReactNode;
    initialValues: FormData;
    onSubmit: (
        values: FormData,
        formikBag: FormikHelpers<FormData>
    ) => void | Promise<any>;
}

const Wizard: React.FC<Props> = ({ children, initialValues, onSubmit }) => {
    const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(
        null
    );
    const [stepNumber, setStepNumber] = useState<number>(0);
    const steps = React.Children.toArray(children);
    const [snapshot, setSnapshot] = useState(initialValues);

    const step: any = steps[stepNumber];
    const isLastStep = stepNumber === steps.length - 1;

    const next = (values: any) => {
        setSnapshot(values);
        if (stepNumber < 2) {
            setStepNumber(stepNumber + 1);
        }
    };

    const previous = (values: any) => {
        setSnapshot(values);
        setStepNumber(0);
    };

    const handleSubmit = async (
        values: FormData,
        bag: FormikHelpers<FormData>
    ) => {
        if (step.props.onSubmit) {
            await step.props.onSubmit(values, bag);
        }

        if (isLastStep) {
            try {
                return await onSubmit(values, bag);
            } catch (error: any) {
                if (error?.message) {
                    setSubmitErrorMessage(error.message);
                } else {
                    setSubmitErrorMessage('Неопределенная ошибка');
                }
            }
        } else {
            bag.setTouched({});
            next(values);
        }
    };

    return (
        <Formik
            initialValues={snapshot}
            onSubmit={handleSubmit}
            validationSchema={step.props.validationSchema}
        >
            {(formik) => (
                <Form className={styles.container}>
                    <Role />

                    <div className={styles.opportunities}>
                        Возможности <Link href="/customers">заказчиков</Link> и{' '}
                        <Link href="/members">участников</Link> на нашей
                        площадке
                    </div>

                    {step}

                    {Boolean(submitErrorMessage) && (
                        <ErrorMessage className={styles.submitError}>
                            {submitErrorMessage}
                        </ErrorMessage>
                    )}

                    <div className={styles.submit}>
                        {stepNumber > 0 && (
                            <button
                                onClick={() => previous(formik.values)}
                                type="button"
                                className={styles.prevBtn}
                            >
                                Назад
                            </button>
                        )}
                        {isLastStep ? (
                            <button
                                disabled={formik.isSubmitting}
                                type="submit"
                                className={styles.regBtn}
                            >
                                Зарегистрироваться
                            </button>
                        ) : (
                            <button
                                disabled={formik.isSubmitting}
                                type="submit"
                                className={styles.nextBtn}
                            >
                                Далее
                            </button>
                        )}
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default Wizard;
